import { render, staticRenderFns } from "./ImportWithAI.vue?vue&type=template&id=2f53bced&scoped=true&"
import script from "./ImportWithAI.vue?vue&type=script&lang=js&"
export * from "./ImportWithAI.vue?vue&type=script&lang=js&"
import style0 from "./ImportWithAI.vue?vue&type=style&index=0&id=2f53bced&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f53bced",
  null
  
)

export default component.exports